module.exports = "/_next/static/images/logo-devpleno-black-ef0d5daf2e10048f1fe86d9b111de3a8.svg";